<template>
  <div class="course-plan">
    <p class="plan_header">
      Учебный план данного курса (создавайте урок)
    </p>

    <draggable
      handle=".before"
      v-model="newStages"
      @start="drag = true"
      @end="onDragEnd"
      class="lessons_list"
      v-bind="dragOptions"
    >
      <CoursePlanItem
        v-for="(element, i) in stagesList"
        :key="i"
        :item="item"
        :element="element"
        :index="i"
        :authors-list="authorsList"
        :course-info="courseInfo"
        @delete="(stage) => $emit('delete', stage)"
        @open-content="openContentCreatePage"
      />
    </draggable>

    <div v-if="!lessonCreation" @click="lessonCreation = !lessonCreation" class="create-lesson-button">
      <i class="mdi mdi-file-document-box-plus-outline"></i> Создать новый урок
    </div>

    <div v-else class="plan_filter">
      <form @submit.prevent="submitLesson" class="row">
        <b-field label="Тип урока:" type="is-info" class="type_select">
          <b-select v-model="newStage.type" placeholder="Тип урока" required>
            <option :value="0">Тип урока</option>
            <option :value="1">Урок</option>
            <option :value="2">Обучающий тест</option>
            <option :value="3">Итоговый тест</option>
          </b-select>
        </b-field>
        <b-field
          label="Название урока:"
          class="lesson_name"
          type="is-info"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            name="name"
            type="text"
            v-model="newStage.name"
            placeholder="Название урока"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <div class="buttons_block">
          <div class="discard_plan" @click="discardNewLesson">Очистить поля</div>
          <button type="submit" class="add_plan" :disabled="errors.items.length > 0">Добавить урок</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import CoursePlanItem from '@/components/admin/all-courses/CoursePlanItem'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    draggable,
    CoursePlanItem
  },
  props: {
    stagesList: {
      default: () => null,
      required: false,
      type: Array
    },
    authorsList: {
      default: () => null,
      required: false,
      type: Array
    },
    newStage: {
      default: () => {},
      type: Object
    },
    courseInfo: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      lessonCreation: false,
      drag: false,
      item: {
        text: 'Добавить материал',
        disabled: true,
        action: 'open-content'
      },
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено'
          }
        }
      }
    }
  },
  methods: {
    onDragEnd() {
      this.drag = false
      let request = []
      this.newStages.forEach((stage, index) => {
        request.push({ stage_id: stage.id, sort_number: index })
      })
      this.$axios2
        .post('courses/' + this.courseId + '/stages/sort', request)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
        })
        .catch(this.$errorToast)
    },
    discardNewLesson() {
      this.lessonCreation = !this.lessonCreation
      this.$emit('abort')
    },
    submitLesson() {
      this.$validator.validateAll().then((result) => {
        if (this.newStage.type <= 0) {
          this.$buefy.toast.open(toastDanger('Тип урока - обязательное поле'))
          return
        }
        if (result) {
          this.$emit('submit')
          this.lessonCreation = !this.lessonCreation
          return
        }
      })
    },
    openContentCreatePage(stageId) {
      this.$router.push('/all-courses/content/' + stageId)
    }
  },
  computed: {
    courseId() {
      return Number(this.$route.params.id)
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: this.courseInfo.status ? true : false,
        // disabled: true,
        ghostClass: 'ghost'
      }
    },
    newStages: {
      get() {
        return this.$store.state.courses.stagesList
      },
      set(value) {
        this.$store.commit('setStagesList', { list: value })
      }
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
